import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import type { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Marker, MarkerSet } from '@go-modules/interfaces/markers/marker';
import { openManagedMatDialog } from '@go-modules/utilities';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export interface PreviewMarkerSetDialogData {
	markerSet: MarkerSet;
	aiStyle?: boolean;
	withName?: boolean;
	dialogTitleId?: string;
}

@Component({
	selector: 'preview-marker-set-dialog',
	templateUrl: './preview-marker-set-dialog.component.html',
	styleUrls: ['./preview-marker-set-dialog.component.scss'],
	standalone: false
})
export class PreviewMarkerSetDialogComponent {
	public markers: Marker[] = [];
	constructor (
		@Inject(MAT_DIALOG_DATA) public data: PreviewMarkerSetDialogData,
		private dialogRef: MatDialogRef<PreviewMarkerSetDialogData>
	) {
		this.data.dialogTitleId ??= PreviewMarkerSetDialogComponent.getDialogTitleId();
		this.markers = this.data.markerSet.tags.sort((a, b) => a.sort_index - b.sort_index);
	}

	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<PreviewMarkerSetDialogData>
	): MatDialogRef<PreviewMarkerSetDialogComponent, void> {
		const dialogTitleId = config?.data?.dialogTitleId ?? PreviewMarkerSetDialogComponent.getDialogTitleId();

		return openManagedMatDialog(dialog, PreviewMarkerSetDialogComponent, {
			...(config ?? {}),
			data: {
				...(config?.data ?? {}),
				dialogTitleId
			},
			ariaLabelledBy: dialogTitleId
		});
	}

	private static getDialogTitleId (): string {
		return `preview-marker-set-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	}

	public close () {
		this.dialogRef.close();
	}
}
